import { Flex, FolderIcon, Skeleton } from '@buffer-mono/popcorn'

import styles from './ListHeader.module.css'
import { FeedItemIcon } from '../FeedIcon/FeedIcon'

type ListHeaderIconProps = {
  title: string
  isLoading: boolean
  isCollection: boolean
  domain?: string
}

export const ListHeaderIcon = ({
  title,
  isCollection,
  domain,
  isLoading,
}: ListHeaderIconProps): JSX.Element => {
  if (isLoading) {
    return (
      <Skeleton
        className={styles.skeletonNoShrink}
        width={48}
        height={48}
        rounded
      />
    )
  }

  if (isCollection) {
    return (
      <Flex
        align="center"
        justify="center"
        className={styles.titleIconContainer}
      >
        <FolderIcon className={styles.titleIcon} />
      </Flex>
    )
  }

  return (
    <FeedItemIcon
      feedName={title}
      url={domain}
      aria-hidden="true"
      size="large"
    />
  )
}
